import { NgModule } from "@angular/core";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { ApiRoutes } from "../../shared/api-routes";
import { HomeComponent } from "./home.component";
import { HomeRoutingModule } from "./home-routing.module";
import { ChartsModule } from "ng2-charts";

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    HomeRoutingModule,
    TranslateModule,
    SharedModule,
    ChartsModule
  ],
  providers: [ApiRoutes],
  exports: [
    HomeComponent
  ]
})
export class HomeModule {
  constructor(public translate: TranslateService) {
  }
}
